"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVCx = void 0;
const _1 = require(".");
const typeName = 'SVCx';
class SVCx extends _1.Irrigator {
    constructor(ob) {
        var _a;
        super({ ...ob, type: (_a = ob.type) !== null && _a !== void 0 ? _a : typeName });
        this.type = typeName;
    }
}
exports.SVCx = SVCx;
